var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container login-page site__block"},[_c('div',{staticClass:"row login-page__row align-content-center justify-content-center"},[_c('div',{staticClass:"col-10 col-lg-4"},[_c('login')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }